import React from "react";
import omit from "lodash/omit";
import round from "lodash/round";
import PropTypes from "prop-types";
import convert from "convert-units";
import escapeName from "../../utils/escape-form-name";

const numberReg = /-?(\d+(\.\d*)?)?/;
const notNumberReg = /[^-\.0-9]/g;

class UnitInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);

    this.state = {
      lastUnit: ctx.locals.units,
    };

    this.handleUnitChange = this.handleUnitChange.bind(this);
  }

  cleanNumber({ target }) {
    if (target.value === "" || target.value == null) return;
    const value = target.value.replace(notNumberReg, "");
    const match = (value.match(numberReg) || [])[0];
    if (target.value !== match) target.value = match;
  }

  handleUnitChange(e) {
    if (this.state.lastUnit !== e.target.value) {
      this.setState({
        lastUnit: e.target.value,
      });
      let to;
      let from;
      if (e.target.value === "imperial") {
        to = "lb";
        from = "kg";
      } else {
        to = "kg";
        from = "lb";
      }
      const { input } = this.refs;
      input.value = round(convert(input.value).from(from).to(to), 2);
    }
  }

  render() {
    const { units } = this.context.locals;
    const { name, defaultValue, metric, imperial, notRound } = this.props;
    const value =
      notRound && defaultValue
        ? convert(defaultValue).from(metric).to(this.props[units])
        : defaultValue &&
          round(convert(defaultValue).from(metric).to(this.props[units]), 2);
    const { lastUnit } = this.state;

    const path = escapeName(name);
    const handleUnitChange = this.handleUnitChange;

    return (
      <div className="unit-input">
        <input
          ref="input"
          className="text-input"
          inputMode="numeric"
          pattern="-?\d+(\.\d+)?"
          data-name={path}
          {...omit(this.props, [
            "metric",
            "imperial",
            "handleUnitChange",
            "units",
          ])}
          onChange={this.cleanNumber}
          defaultValue={value}
        />

        <div className="units-toggle">
          <input
            type="hidden"
            name={`_units[${path}][metric]`}
            value={metric}
          />

          <input
            type="hidden"
            name={`_units[${path}][imperial]`}
            value={imperial}
          />

          <label className={lastUnit === "metric" ? "active" : ""}>
            <input
              ref="metric"
              type="radio"
              name={`_units[${path}][type]`}
              key={this.props.units}
              defaultChecked={units === "metric"}
              defaultValue="metric"
              onClick={handleUnitChange}
            />
            <b>{metric}</b>
          </label>

          <label className={lastUnit !== "metric" ? "active" : ""}>
            <input
              ref="imperial"
              type="radio"
              name={`_units[${path}][type]`}
              key={this.props.units}
              defaultChecked={units !== "metric"}
              defaultValue="imperial"
              onClick={handleUnitChange}
            />
            <b>{imperial}</b>
          </label>
        </div>
      </div>
    );
  }
}

UnitInput.contextTypes = { locals: PropTypes.object };

export default UnitInput;
